import { render } from "./BlogPage.vue?vue&type=template&id=d8a1c20e&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=d8a1c20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a1c20e"]])

export default __exports__